import head from 'lodash/head';
import { call, delay, put, select, takeLatest } from 'redux-saga/effects';

import { showAlert } from '../Dashboard/actions';

import {
  saveAgenciesList,
  setAgenciesListIsLoading,
  setAgenciesListIsNotLoading,
  setProfileFormIsLoading,
  setProfileFormIsNotLoading,
  setProfileFormIsNotEditable,
  setAgencyCredentialsListIsLoading,
  saveAgencyCredentialsList,
  setAgencyCredentialsListIsNotLoading,
  setCredentialFormIsLoading,
  setCredentialFormIsNotLoading,
  setHideCredentialForm,
} from './actions';
import {
  agenciesUpdateSuccessAlert,
  createCredentialSuccessAlert,
  editCredentialSuccessAlert,
  text,
  threeSeconds,
} from './constants';
import {
  FETCH_AGENCIES_LIST,
  SET_AGENCIES_FILTERS,
  UPDATE_AGENCY_INFO,
  FETCH_AGENCY_CREDENTIALS,
  FETCH_SAVE_CREDENTIAL,
} from './actionTypes';
import {
  getAgenciesFilters,
  selectCredentialFormMode,
  selectCurrentSelectedAgencyId,
} from './selectors';
import {
  getAgenciesReports,
  fetchUpdateAgency,
  getAgenciesCredentials,
  fetchSaveCredential,
} from './services';

function* callFetchAgencies() {
  yield put(setAgenciesListIsLoading());
  const agenciesFilter = yield select(getAgenciesFilters);
  const agenciesList = yield call(getAgenciesReports, agenciesFilter);
  yield put(saveAgenciesList(agenciesList));
  yield put(setAgenciesListIsNotLoading());
}

function* callUpdateAgencyInfo({ values }) {
  yield put(setProfileFormIsLoading());
  const agencyId = yield select(selectCurrentSelectedAgencyId);
  const response = yield call(fetchUpdateAgency, { agencyId, values });

  if (!response.ok) {
    const errorMessage = yield call(head, response.error.errors);
    yield put(showAlert({ color: 'error', icon: 'exclamation', message: errorMessage }));
    yield put(setProfileFormIsNotLoading());

    return;
  }

  yield put(showAlert(agenciesUpdateSuccessAlert));
  yield delay(threeSeconds);
  yield call(callFetchAgencies);
  yield put(setProfileFormIsNotLoading());
  yield put(setProfileFormIsNotEditable());
}

function* callFetchCredentials() {
  yield put(setAgencyCredentialsListIsLoading());
  const agencyId = yield select(selectCurrentSelectedAgencyId);
  const credentialsList = yield call(getAgenciesCredentials, agencyId);
  yield put(saveAgencyCredentialsList(credentialsList));
  yield put(setAgencyCredentialsListIsNotLoading());
}

function* callFetchSaveCredential({ values }) {
  yield put(setCredentialFormIsLoading());
  const formMode = yield select(selectCredentialFormMode);
  const agencyId = yield select(selectCurrentSelectedAgencyId);
  const response = yield call(fetchSaveCredential, { ...values, agencyId });

  if (!response.ok) {
    const errorMessage = yield call(head, response.error.errors);
    yield put(showAlert({ color: 'error', icon: 'exclamation', message: errorMessage }));
    yield put(setCredentialFormIsNotLoading());

    return;
  }

  if (formMode === text.createMode) {
    yield put(showAlert(createCredentialSuccessAlert));
  } else {
    yield put(showAlert(editCredentialSuccessAlert));
  }

  yield put(setCredentialFormIsNotLoading());
  yield put(setHideCredentialForm());
  yield delay(threeSeconds);
  yield call(callFetchCredentials);
}

function* agenciesWatcher() {
  yield takeLatest(FETCH_AGENCIES_LIST, callFetchAgencies);
  yield takeLatest(SET_AGENCIES_FILTERS, callFetchAgencies);
  yield takeLatest(UPDATE_AGENCY_INFO, callUpdateAgencyInfo);
  yield takeLatest(FETCH_AGENCY_CREDENTIALS, callFetchCredentials);
  yield takeLatest(FETCH_SAVE_CREDENTIAL, callFetchSaveCredential);
}

export { agenciesWatcher, callFetchAgencies };
